import "core-js/modules/es.array.reduce";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function concatBuffers() {
  for (var _len = arguments.length, inputBuffers = new Array(_len), _key = 0; _key < _len; _key++) {
    inputBuffers[_key] = arguments[_key];
  }

  var neededLength = inputBuffers.reduce(function (sum, buff) {
    return sum + buff.byteLength;
  }, 0);
  var outputBuffer = new Uint8Array(neededLength);
  var offset = 0;
  inputBuffers.forEach(function (buff) {
    if (ArrayBuffer.isView(buff)) {
      var buffer = buff.buffer,
          byteOffset = buff.byteOffset,
          byteLength = buff.byteLength;
      outputBuffer.set(new Uint8Array(buffer, byteOffset, byteLength), offset);
    } else {
      outputBuffer.set(new Uint8Array(buff), offset);
    }

    offset += buff.byteLength;
  });
  return outputBuffer;
}